import { SubFuncion } from "../../../../../infraestructure/persistence/rest/SubFuncionesAdapter"

export const createOptions = (data:any) =>{
  return data.map((s: SubFuncion)=> { return { label: s.subFuncion, value: s.idSubFuncion } })
}

// export const createFuncSubFunc = (data:any) =>{
//   return data.map((s: any)=> { return {idFuncion:s.idFuncion, idSubFuncion:s.idSubFuncion} })
// }